import { TextUtils } from '@toro/common/shared/resources/text.utils';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { SuitabilityAction } from '@toro/common/shared/state-management/suitability/suitability.action';
import { FormControl, FormGroup } from '@angular/forms';
import { FieldError } from '@toro/common/shared/models/form/FieldError';
import { LayerService } from '@toro/common/shared/services/LayerService';
import { Component, OnInit, VERSION } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Store } from '@ngrx/store';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { RouterTrackerService } from '@toro/common/shared/services/router-tracker/router-tracker.service';
import { MetaTagType } from '@toro/common/shared/enum/seo/meta-tag-type.enum';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { PushNotificationService } from '@toro/common/shared/services/push-notification/push-notification.service';
import { StorageService } from '@toro/common/shared/services/storage.service';
import { SuitabilityProfilesEnum } from '@toro/common/shared/enum/suitability/suitability-profiles.enum';
import { BackendRegistationStatus } from '@toro/common/shared/enum/backend-registration-status.enum';
import { NavigationService } from '@toro/common/shared/services/navigation/navigation.service';
import { AppcuesService } from '@toro/common/shared/services/appcues/appcues.service';
import { ImportedBy } from '@toro/common/shared/enum/user/importedby';
import { filter, first, map, mergeMap } from 'rxjs/operators';
import { environment } from '@hub-workspace/apps/stock/src/environments/environment';

// tslint:disable-next-line:no-var-requires
const { version: appVersion } = require('../../../../package.json');
// tslint:disable-next-line:no-var-requires
const commonPackageVersion = '@toro/common/package.json';
const defaultTitle = `${ environment.isNewBrand ? "Santander Corretora" : "Toro Investimentos" } - A melhor experiência digital de investimentos`;
const defaultMetaTags = [{ name: MetaTagType.Description, content: 'A melhor experiência digital de investimentos do mundo - Crie o seu Futuro' }];
declare var $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    public questions: any[] = [];
    public answersList: any[] = [];
    public subQuestions: any[] = [];
    public secondSubQuestions: any[] = [];
    public question: any;
    public secondQuestion: any;
    public pending: boolean = false;
    public firstQuestionUser: boolean = false;
    public secondQuestionUser: boolean = false;
    public isLiveAttached: boolean = true;

    constructor(
        public router: Router,
        public store: Store<any>,
        public layerService: LayerService,
        public dialogsService: DialogsService,
        public AR: ActivatedRoute,
        private settingsService: SettingsService,
        private routeTracker: RouterTrackerService,
        private activatedRoute: ActivatedRoute,
        private textUtils: TextUtils,
        private pushNotification: PushNotificationService,
        private navigationService: NavigationService,
        private appcuesService: AppcuesService,
    ) {
        this.settingsService.setAppVersion(appVersion);
        this.settingsService.setCommonPackageVersion(commonPackageVersion);
        this.settingsService.setDefaultTitle(defaultTitle);
        this.settingsService.setDefaultMetaTags(defaultMetaTags);
        this.routeTracker.startTracking();

        console.log('Angular Version:', VERSION.full);

        this.navigationService.handleNavigationError();
        this.appcuesService.listenAndShowFlowsByURL();

        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            const anchor: string = this.AR.snapshot.fragment;
            const section = document.querySelector(`#${anchor}`) as HTMLElement;
            if (section) {
                $('html, body')
                    .animate({
                        scrollTop: section.offsetTop - 100,
                    }, 1200);
            } else {
                window.scroll(0, 0);
            }
            this.store.dispatch({ type: TrackingActions.updateDataPage });
        });

        (FormGroup.prototype as any).validFields = function (err: FieldError[]) {
            err.forEach((e) => {
                const field: FormControl = this.get(e.field) as FormControl;
                if (field) field.setErrors({ backendError: { message: e.message } });
            });
        };

        this.textUtils.extendStringPrototype();

    }

    public ngOnInit() {
        this.pushNotification.getPermission();

        // atualização do title e metatags
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map((route) => {
                while (route.firstChild) {
                    route = route.firstChild;
                }
                return route;
            }),
            filter((route) => route.outlet === 'primary'),
            mergeMap((route) => route.data)
        ).subscribe((event) => {
            let metaData: any;
            if (event && event.metaData) {
                metaData = event.metaData as { title: string, metaTags: Array<{ name: string, content: string }> };
            } else {
                metaData = {} as any;
            }
            this.settingsService.updatePageTitle(metaData.title);
            this.settingsService.updateMetaTags(metaData.metaTags);
        });

        this.store
            .select((globalStore) => globalStore.globals.liveIsAttached)
            .subscribe((isAttached) => {
                this.isLiveAttached = isAttached;
            });
    }

    public ngAfterViewInit() {
        this.saveCookieGclid();
    }

    /**
     * Método que faz a lógica que salva o GClid do usuário nos cookies para a rota do Salesforce
     */
    public saveCookieGclid() {
        // Pega código do Gclid que tá na url
        this.activatedRoute.queryParams.pipe(
            filter((params) => !!params.gclid)
        )
            .subscribe((params) => {
                if (params.gclid) {
                    // Pega o código que está salvo no cookie
                    const cookieGclid = StorageService.getCookie('hub$user$gclid');
                    if (!cookieGclid || params.gclid !== cookieGclid) {
                        StorageService.setCookie('hub$user$gclid', params.gclid, new Date('01-01-2100'), 'max-age');
                    }
                }
            });
    }

    public ngAfterContentInit() {
        this.store.select((state) => state.authentication.currentUser).pipe(
            filter((data) => !!data && !!data.cblc),
            first()
        ).subscribe((data) => {
            this.store.dispatch({ type: SuitabilityAction.getUserAnswers });
            this.store.dispatch({ type: SuitabilityAction.getAnswers });
            this.store.dispatch({ type: SuitabilityAction.getQuestions });
        });

        // Verifica se o usuário está como "Sem Perfil" no suitability
        // e lança um dialog pedindo a atualização das informações
        this.store
            .select(({ userProfile, suitability }) => ({
                userProfile,
                suitability,
            }))
            .pipe(
                filter(({ suitability }) => !!suitability.profile),

                // Filtra por usuários sem suitability completo
                filter(
                    ({ suitability }) =>
                        suitability.profile.profile === SuitabilityProfilesEnum.NoProfile,
                ),

                // Filtra por usuários com o cadastro já completo
                filter(({ userProfile }) => {
                    switch (userProfile.user.registrationStatus) {
                        case BackendRegistationStatus.Canceled: return false;
                        case BackendRegistationStatus.Filling: return false;
                        case BackendRegistationStatus.None: return false;

                        default: return true;
                    }
                }),
                first()
            )
            .subscribe(({ userProfile: { user } }) => {
                let { importedBy } = user;

                const isImportedBy = (importedBy >= ImportedBy.Pi) && (importedBy <= ImportedBy.IndentifiedPi);

                if (isImportedBy) return;
            });
    }

    /**
     * Redireciona para uma rota do Hub
     * @param url
     */
    public redirectExternal(url: string) {
        window.location.href = `${url}`;
    }
}
